<template>
  <div class="product-page">
    <AppHeader />

    <!-- Banner -->
    <div class="pro-banner"></div>

    <!-- 标题 -->


    <!-- 悦享超级卡介绍 -->
    <div class="container" style="padding: 0 20px 60px;text-align: left;margin-top: 30px;">
      <div class="content-block">
        <div class="content-img">
          <img src="//34188381.s21i.faiusr.com/2/ABUIABACGAAglPylzwYo2MrZvQYwrQU4oQg.jpg" alt="">
        </div>
        <div class="content-text">
          <h2>悦享超级卡</h2>
          <p>支持兑换悦享商城的电影演出、甜品蛋糕、电子券、图书、美食、家电、婴童、服饰等品类的 <span style="color:red;font-weight:bold;">400000+</span>
            优质产品。商城优选全球好货，海量福利商品任性挑选。作为一站式员工福利生态平台，打造包含文化福利、生日关怀、节日慰问、餐补、线上线下活动、优惠券等多重场景的综合性福利体系</p>
          <h3>产品特点</h3>
          <p>使用方式：储值类点卡，使用卡内点数兑换商城福利商品；</p>
          <p>功能属性：充值、查询、兑换、多卡合并支付等功能；</p>
        </div>
      </div>
    </div>

    <!-- 全品类覆盖 -->
    <div style="background: #fafafa; padding: 60px 0;">
      <div class="container">
        <h2 style="text-align:center; font-size:36px; margin-bottom:50px;"><b>全品类覆盖</b></h2>
        <div class="category-grid">
          <div class="category-item" v-for="item in categories" :key="item.name">
            <img :src="item.img" :alt="item.name">
            <div style="position: absolute; background: rgba(255, 255, 255, 0.7);position: absolute;
    bottom: 33px;
    padding-bottom: 20px;
    left: 17%;">
              <div class="cate-line"></div>
              <div class="cate-name">{{ item.name }}</div>
              <div class="cate-desc">{{ item.desc }}</div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- 四大品类 -->
    <div class="container" style="padding: 60px 20px;">
      <div class="four-grid">
        <div class="four-item" v-for="item in fourTypes" :key="item.name">
          <img :src="item.img" :alt="item.name">
          <p class="four-name">{{ item.name }}</p>
        </div>
      </div>
    </div>

    <!-- 福利卡使用流程 -->
    <!-- <div style="background: #fafafa; padding: 60px 0;">
      <div class="container">
        <p style="text-align:center; color:#e5e5e5; font-size:36px;">Using Processes</p>
        <h2 style="text-align:center; font-size:36px; margin-bottom:50px;"><b>福利卡使用流程</b></h2>
        <div class="flow-steps">
          <div class="flow-item" v-for="(step, idx) in flowSteps" :key="idx">
            <img :src="step.img" :alt="step.title">
            <p class="flow-title">{{ step.title }}</p>
            <p class="flow-desc">{{ step.desc }}</p>
          </div>
          <div class="process-arrow">›</div>
        </div>
      </div>
    </div> -->
    <!-- <section class="section process-section" style="margin-top: 100px;">
      <div class="container">
        <div class="section-label">USING PROCESSES</div>
        <h2 class="section-heading">福利卡使用流程</h2>

        <div class="process-steps">
          <div class="process-item">
            <div class="process-card">
              <img class="process-icon" src="../src/assets/1.png" alt="关注公众号">
            </div>
            <div class="process-name">关注公众号</div>
            <div class="process-desc">关注微信公众号“悦享聚汇”，选择【悦享臻选】板块</div>
          </div>
          <div class="process-arrow">›</div>
          <div class="process-item">
            <div class="process-card">
              <img class="process-icon" src="../src/assets/2.png" alt="进入悦享蛋糕">
            </div>
            <div class="process-name">进入悦享商城</div>
            <div class="process-desc">进入悦享商城登陆账号，选择福利卡进行绑定</div>
          </div>
          <div class="process-arrow">›</div>
          <div class="process-item">
            <div class="process-card">
              <img class="process-icon" src="../src/assets/3.png" alt="绑定福利卡">
            </div>
            <div class="process-name">绑定福利卡</div>
            <div class="process-desc">输入卡号、密码或扫描二维码完成超级卡的绑定</div>
          </div>
          <div class="process-arrow">›</div>
          <div class="process-item">
            <div class="process-card">
              <img class="process-icon" src="../src/assets/4.png" alt="选择心仪商品">
            </div>
            <div class="process-name">选择心仪商品</div>
            <div class="process-desc">选择商品加入购物车进行下单，可通过我的订单查询信息</div>
          </div>
        </div>
      </div>
    </section> -->
    <ComsPross />

    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/head.vue'
import AppFooter from '@/components/foot.vue'
import ComsPross from '@/components/coms2.vue';
export default {
  name: 'Pro1',
  components: { AppHeader, AppFooter,ComsPross },
  data() {
    return {
      categories: [
        { name: '粮油副食', desc: '品质优选，一站配齐', img: '//34188381.s21i.faiusr.com/2/ABUIABACGAAgypmnzwYowPTN7wYw7gU4tQk!450x450.jpg' },
        { name: '清洁好物', desc: '一擦焕新超省心的清洁好帮手', img: '//34188381.s21i.faiusr.com/2/ABUIABACGAAgqZunzwYogKKXsAYw4AU4nAo!450x450.jpg' },
        { name: '家用电器', desc: '经久耐用、智能高效', img: '//34188381.s21i.faiusr.com/2/ABUIABACGAAg95ynzwYoh_Op3gEwkg44ihI!450x450.jpg' }
      ],
      fourTypes: [
        { name: '生日蛋糕  悦享美味', img: '//34188381.s21i.faiusr.com/4/ABUIABAEGAAg1KanzwYopPO8xAYwyAE4yAE.png' },
        { name: '电影演出  悦享影音', img: '//34188381.s21i.faiusr.com/4/ABUIABAEGAAgi6mnzwYonpT9ugcwyAE4yAE.png' },
        { name: '图书频道  悦享知识', img: '//34188381.s21i.faiusr.com/4/ABUIABAEGAAgkqunzwYolJ7SwgQwyAE4yAE.png' },
        { name: '景区门票  悦享休闲', img: '//2.ss.508sys.com/image/materialLib/other/500000160.png' }
      ],
      flowSteps: [
        { title: '关注公众号', desc: '关注微信公众号"悦享聚汇"，选择【悦享臻选】板块', img: require('../src/assets/1.png'), },
        { title: '进入悦享商城', desc: '进入悦享商城登陆账号，选择福利卡进行绑定', img: require('../src/assets/2.png'), },
        { title: '绑定福利卡', desc: '输入卡号、密码或扫描二维码完成超级卡的绑定', img: require('../src/assets/3.png'), },
        { title: '选择心仪商品', desc: '选择商品加入购物车进行下单，可通过我的订单查询信息', img: require('../src/assets/4.png'), }
      ]
    }
  }
}
</script>

 <style scoped>
/* ========== 全局样式 ========== */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ========== Banner ========== */
.pro-banner {
  height: 800px;
  background: url(../src/assets/bb4.png) center/cover no-repeat;
}

.pro-title {
  font-size: 30px;
  text-align: center;
  color: #333;
}

.pro-line {
  width: 60px;
  height: 2px;
  background: #c40000;
  margin: 20px auto;
}

.pro-desc {
  text-align: center;
  color: #666;
  font-size: 16px;
  line-height: 1.8;
  max-width: 800px;
  margin: 0 auto;
}

/* ========== 悦享超级卡介绍 ========== */
.content-block {
  display: flex;
  gap: 40px;
  align-items: flex-start;
}

.content-img {
  width: 200px;
  flex-shrink: 0;
}

.content-img img {
  width: 100%;
  border-radius: 8px;
}

.content-text {
  flex: 1;
  line-height: 2;
  color: #666;
  min-width: 0;
}

.content-text h2 {
  font-size: 20px;
  color: #333;
  margin-bottom: 16px;
}

.content-text h3 {
  font-size: 20px;
  color: #333;
  margin: 20px 0 10px;
}

/* ========== 全品类覆盖 ========== */
.category-grid {
  display: flex;
  justify-content: center;
  gap: 130px;
  text-align: center;
}

.category-item {
  width: 277px;
  position: relative;
}

.category-item img {
  width: 100%;
  height: 427px;
  object-fit: cover;
  border-radius: 8px;
}

.category-overlay {
  position: absolute;
  background: rgba(255, 255, 255, 0.7);
  bottom: 33px;
  padding-bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  border-radius: 4px;
}

.cate-line {
  width: 188px;
  height: 1px;
  background: #c8c9c3;
  margin: 16px auto;
}

.cate-name {
  font-size: 18px;
  color: #333;
  font-weight: bold;
}

.cate-desc {
  font-size: 12px;
  color: #666;
  margin-top: 8px;
}

/* ========== 四大品类 ========== */
.four-grid {
  display: flex;
  justify-content: center;
  gap: 107px;
  text-align: center;
}

.four-item {
  width: 200px;
}

.four-item img {
  width: 100%;
  height: 200px;
  object-fit: contain;
  border-radius: 8px;
}

.four-name {
  font-size: 20px;
  color: #333;
  margin-top: 20px;
}

/* ========== 旧的流程（保留备用） ========== */
.flow-steps {
  display: flex;
  justify-content: center;
  gap: 112px;
  text-align: center;
}

.flow-item {
  width: 160px;
}

.flow-item img {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  object-fit: contain;
  padding: 10px;
}

.flow-title {
  font-size: 16px;
  font-weight: bold;
  color: #000;
  margin: 15px 0 10px;
}

.flow-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

/* ========== 福利卡使用流程（新版） ========== */
.process-section {
  padding: 60px 0;
  margin-top: 0;
}

.section-label {
  text-align: center;
  color: #e5e5e5;
  font-size: 36px;
  font-weight: bold;
}

.section-heading {
  text-align: center;
  color: #353535;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 50px;
}

.process-steps {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 0;
  margin-top: 50px;
  padding-bottom: 50px;
}

.process-item {
  text-align: center;
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.process-card {
  width: 125px;
  height: 125px;
  margin: 0 auto 30px;
  flex-shrink: 0;
}

.process-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.process-item-text {
  width: 100%;
  padding: 0 10px;
}

.process-name {
  font-size: 16px;
  font-weight: bold;
  color: #000;
  margin-bottom: 10px;
}

.process-desc {
  font-size: 14px;
  color: #666;  padding:  0 50px;
  line-height: 1.6;
  word-break: break-word;
}

.process-arrow {
  font-size: 32px;
  color: #ccc;
  margin-top: 50px;
  flex-shrink: 0;
}

/* ========== 响应式设计 ========== */
@media (max-width: 1024px) {
  .pro-banner {
    height: 500px;
  }
  
  .section-label {
    font-size: 28px;
  }
  
  .section-heading {
    font-size: 28px;
    margin-bottom: 35px;
  }
  
  .category-grid {
    gap: 60px;
  }
  
  .four-grid {
    gap: 50px;
    flex-wrap: wrap;
  }
  
  .four-item {
    width: 150px;
  }
}

@media (max-width: 768px) {
  .pro-banner {
    height: 300px;
  }
  
  /* 悦享超级卡介绍 */
  .content-block {
    flex-direction: column;
    align-items: center;
  }
  
  .content-img {
    width: 180px;
    margin-bottom: 20px;
  }
  
  .content-text {
    text-align: center;
  }
  
  .content-text h2 {
    font-size: 18px;
  }
  
  .content-text h3 {
    font-size: 18px;
  }
  
  .content-text p {
    font-size: 14px;
    line-height: 1.8;
  }
  
  /* 全品类覆盖 */
  .category-grid {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }
  
  .category-item {
    width: 100%;
    max-width: 350px;
  }
  
  .category-item img {
    height: 350px;
  }
  
  .category-overlay {
    bottom: 20px;
    width: 85%;
  }
  
  .cate-line {
    width: 120px;
    margin: 10px auto;
  }
  
  /* 四大品类 */
  .four-grid {
    gap: 30px;
    flex-wrap: wrap;
  }
  
  .four-item {
    width: calc(50% - 30px);
    min-width: 140px;
  }
  
  .four-item img {
    height: 150px;
  }
  
  .four-name {
    font-size: 16px;
  }
  
  /* 福利卡使用流程 - 移动端优化 */
  .process-section {
    padding: 40px 0;
  }
  
  .section-label {
    font-size: 22px;
  }
  
  .section-heading {
    font-size: 22px;
    margin-bottom: 25px;
  }
  
  .process-steps {
    flex-direction: column;
    align-items: center;
    gap: 15px;
    margin-top: 30px;
  }
  
  .process-item {
    width: 100%;
    max-width: 320px;
    flex-direction: row;
    align-items: center;
    gap: 15px;
    text-align: left;
  }
  
  .process-card {
    width: 70px;
    height: 70px;
    margin: 0;
  }
  
  .process-item-text {
    flex: 1;
    padding: 0;
  }
  
  .process-name {
    font-size: 14px;
    margin-bottom: 5px;
  }
  
  .process-desc {
    font-size: 12px;
    line-height: 1.5;
    padding: 0;
  }
  
  .process-arrow {
    transform: rotate(90deg);
    margin: 0;
    font-size: 24px;
  }
  
  /* 旧流程样式 */
  .flow-steps {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
}

@media (max-width: 480px) {
  .pro-banner {
    height: 200px;
  }
  
  .section-label {
    font-size: 18px;
  }
  
  .section-heading {
    font-size: 20px;
  }
  
  .content-img {
    width: 140px;
  }
  
  .category-item {
    max-width: 280px;
  }
  
  .category-item img {
    height: 280px;
  }
  
  .four-grid {
    gap: 20px;
  }
  
  .four-item {
    width: calc(50% - 20px);
  }
  
  .four-item img {
    height: 120px;
  }
  
  .four-name {
    font-size: 14px;
  }
  
  .process-item {
    max-width: 100%;
    flex-direction: column;
    text-align: center;
    align-items: center;
  }
  
  .process-card {
    width: 60px;
    height: 60px;
    margin-bottom: 10px;
  }
  
  .process-item-text {
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/pruduct4.vue